import script from "./DeleteTask.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteTask.vue?vue&type=script&setup=true&lang=js"

import "./DeleteTask.vue?vue&type=style&index=0&id=75693f9f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75693f9f"]])

export default __exports__